<template>
  <div>
    <div class="subsection">
      <slot></slot>
    </div>

    <Subnav
      :class="{'sidebar': sidebar}"
      :items="subSections"
      :parent="parent" />
  </div>
</template>

<script>
import Subnav from '@/components/Subnav.vue';

export default {
  name: 'SubsectionNavBottom',
  props: {
    parent: String,
    sidebar: Boolean,
    subSections: Array,
  },
  components: {
    Subnav,
  },
};
</script>

<style lang="scss">
  .subsection {
    width: 100%;
  }
</style>
